import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLeads from "@/pages/AdminLeads";
import ServicesGrid from "@/pages/ServicesGrid";
import TemplatePage from "@/pages/TemplatePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-[#0A0D14] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="/services" element={<ServicesGrid />} />
          <Route path="/templates/:siteKey" element={<TemplatePage />} />
          <Route path="/templates/:siteKey/contact" element={<TemplatePage />} />
          <Route path="/templates/:siteKey/:moduleSlug" element={<TemplatePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
